@use '../../../styles/mixins/typography-mixin' as *;

.heading-1 {
  @include heading_1_text();
}
